import { GetVenue } from "@ticketingplatform/api/dist/venue/__generated__/queries";
import { useMemo } from "react";

import { VenueFormValues } from "../VenueForm/types";

type GetVenue_venue = NonNullable<GetVenue["venue"]>;

export const useVenueShape = (
  data: GetVenue_venue | null | undefined
): VenueFormValues | undefined =>
  useMemo(() => {
    if (!data) {
      return undefined;
    }

    const { address, organization, image } = data;
    const { country, countryCode } = address || {};

    return {
      input: {
        ...data,
        organizationId: organization,
        image: image || undefined,
        address: {
          ...address,
          country:
            country && countryCode
              ? {
                  value: countryCode,
                  label: country,
                }
              : undefined,
        },
      },
    };
  }, [data]);
